export default "__VITE_ASSET__405648c7__"